import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";
import { useAuth } from "./AuthContext";

const CurrencyContext = createContext(null);

export function CurrencyProvider({ children }) {
  const { user } = useAuth();
  const [currency, setCurrencyState] = useState(() => {
    return localStorage.getItem("bt_currency") || "USD";
  });
  const [rate, setRate] = useState(85);

  const setCurrency = (c) => {
    setCurrencyState(c);
    localStorage.setItem("bt_currency", c);
  };

  const fetchRate = useCallback(async () => {
    try {
      const { data } = await api.get("/settings/conversion-rate");
      setRate(Number(data.rate) || 85);
    } catch (e) {
      // Expected on bootstrap before auth — keep default rate
      if (process.env.NODE_ENV !== "production") {
        console.debug("[CurrencyContext] fetchRate skipped:", e.message);
      }
    }
  }, []);

  useEffect(() => {
    if (user && typeof user === "object") {
      fetchRate();
    }
  }, [user, fetchRate]);

  const updateRate = async (newRate) => {
    const { data } = await api.put("/settings/conversion-rate", { rate: Number(newRate) });
    setRate(Number(data.rate));
    return data.rate;
  };

  // Convert from base USD value to selected currency
  const convertFromUSD = (usdAmount) => {
    const n = Number(usdAmount || 0);
    return currency === "INR" ? n * rate : n;
  };

  return (
    <CurrencyContext.Provider
      value={{ currency, setCurrency, rate, updateRate, fetchRate, convertFromUSD }}
    >
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  const ctx = useContext(CurrencyContext);
  if (!ctx) throw new Error("useCurrency must be used within CurrencyProvider");
  return ctx;
}
